export default {
  entries: state => state.entries,
  entry: state => state.entry
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/logging/getters.js